module.exports = __webpack_public_path__ + "2e11f48a0e190bd84a5d61bc55342ad8.png";